/** InsCoder WANG.J 2026-07-16 B + Handle anchor scrolling and active state **/
if (!customElements.get('cust-anchor')) {
  customElements.define(
    'cust-anchor',
    class CustAnchor extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-anchor-viewport]');
        this.links = Array.from(this.querySelectorAll('[data-anchor-id]'));
        this.items = this.links
          .map((link) => ({
            link,
            target: this.getTarget(link.dataset.anchorId),
          }))
          .filter((item) => item.target);

        if (!this.items.length) return;

        this.handleClick = this.handleClick.bind(this);
        this.scheduleActiveState = this.scheduleActiveState.bind(this);
        this.links.forEach((link) => link.addEventListener('click', this.handleClick));
        window.addEventListener('scroll', this.scheduleActiveState, { passive: true });
        window.addEventListener('resize', this.scheduleActiveState, { passive: true });

        this.observer = new IntersectionObserver(this.scheduleActiveState, {
          rootMargin: '-' + this.getScrollOffset() + 'px 0px -60% 0px',
          threshold: [0, 0.01, 0.5, 1],
        });
        this.items.forEach(({ target }) => this.observer.observe(target));
        this.scheduleActiveState();
      }

      disconnectedCallback() {
        this.links?.forEach((link) => link.removeEventListener('click', this.handleClick));
        window.removeEventListener('scroll', this.scheduleActiveState);
        window.removeEventListener('resize', this.scheduleActiveState);
        this.observer?.disconnect();
        cancelAnimationFrame(this.activeStateFrame);
      }

      getTarget(id) {
        if (!id) return null;

        const target = document.getElementById(id);
        if (target) return target;

        return Array.from(document.querySelectorAll('[id]')).find(
          (element) => typeof element.id === 'string' && element.id.endsWith('__' + id)
        );
      }

      getScrollOffset() {
        const headerHeight = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--header-height')
        );
        return (Number.isNaN(headerHeight) ? 0 : headerHeight) + 16;
      }

      handleClick(event) {
        const link = event.currentTarget;
        const item = this.items.find((candidate) => candidate.link === link);
        if (!item) return;

        event.preventDefault();
        this.setActiveLink(link);

        const targetTop = item.target.getBoundingClientRect().top + window.scrollY - this.getScrollOffset();
        window.scrollTo({
          top: Math.max(0, targetTop),
          behavior: 'smooth',
        });

        try {
          history.replaceState(null, '', '#' + encodeURIComponent(link.dataset.anchorId));
        } catch {
          // Local theme preview can reject history updates while proxied.
        }
      }

      scheduleActiveState() {
        if (this.activeStateFrame) return;

        this.activeStateFrame = requestAnimationFrame(() => {
          this.activeStateFrame = null;
          this.updateActiveState();
        });
      }

      updateActiveState() {
        const activationLine = this.getScrollOffset() + 1;
        let activeItem = this.items[0];

        this.items.forEach((item) => {
          if (item.target.getBoundingClientRect().top <= activationLine) {
            activeItem = item;
          }
        });

        if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
          activeItem = this.items[this.items.length - 1];
        }

        this.setActiveLink(activeItem.link);
      }

      setActiveLink(activeLink) {
        this.links.forEach((link) => {
          const isActive = link === activeLink;
          link.classList.toggle('btn--active', isActive);
          if (isActive) {
            link.setAttribute('aria-current', 'location');
          } else {
            link.removeAttribute('aria-current');
          }
        });

        if (!this.viewport || !activeLink) return;

        const targetLeft = activeLink.offsetLeft - (this.viewport.clientWidth - activeLink.offsetWidth) / 2;
        this.viewport.scrollTo({
          left: Math.max(0, targetLeft),
          behavior: 'smooth',
        });
      }
    }
  );
}
/** InsCoder WANG.J 2026-07-16 E + Handle anchor scrolling and active state **/
